module.exports = __webpack_public_path__ + "img/hcalc2.7fc7a227.png";